// Folder Item for a folder.  Can contain sub-folders (it's folders all the way down!)
import React from "react";
import "./sourcePicker.css";
import { Form, Button, Col } from "react-bootstrap";
import loader from "../loader";
import { SourceEntity } from "./SourceEntity";
import { getPathByName } from "../../services/sourceManager";

class SourceSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sourceOptions: [],
            isLoading: false,
            foldersSelected: [],
            pathnameValue: "",
            noResults: false
        };
    }
    componentWillMount() {

    }

    componentDidMount() {
        // this.setState({ foldersSelected: this.props.sources ? this.props.sources : [] })
    }

    componentWillUnmount() { }
    onSourceSetter = (sourceObject) => {
        const { sourceOptions } = this.state;
        const updateArray = sourceOptions.filter((source) => {
            if (source.id === sourceObject.id) {
                return false;
            }
            return true;
        })
        this.setState({ sourceOptions: updateArray }, () => {
            this.props.onSourceSetter(sourceObject);
        });
    }
    sourceMapper = () => {
        const { sourceOptions } = this.state;

        const map = sourceOptions.map((source) => {
            return <SourceEntity {...source} key={source.id} onSourceSetter={this.onSourceSetter} />
        })
        return (<ul>
            {map}
        </ul>)
    }
    onSearchPath = async (e) => {
        const { pathnameValue } = this.state;
        e.preventDefault();
        this.setState({ isLoading: true });
        try {
            const sourceOps = await getPathByName(pathnameValue);
            let noRes = false;
            if (sourceOps.message.length === 0) {
                noRes = true;
            }
            this.setState({
                isLoading: false,
                sourceOptions: sourceOps.message,
                noResults: noRes
            })
        } catch (error) {

        } finally {
            this.setState({ isLoading: false });
        }

    }
    componentWillUpdate(nextProps, nextState) {
        // console.S
        if (nextProps.lastRemovedSource !== this.props.lastRemovedSource
            && nextProps.lastRemovedSource !== undefined) {
            const { sourceOptions } = this.state;
            sourceOptions.push(nextProps.lastRemovedSource);
            this.setState({ sourceOptions: sourceOptions });
        }

    }
    onTextChange = (ev) => {
        if (this.state.noResults) {
            this.setState({ noResults: false });
        }
        this.setState({ pathnameValue: ev.target.value })
    };
    render() {
        const { isLoading, sourceOptions, pathnameValue, noResults } = this.state;
        let folderMap = [];
        if (!isLoading && sourceOptions.length > 0) {
            folderMap = this.sourceMapper();
        } else if (!isLoading && noResults) {
            folderMap = <p className="text-center">No results return for: {pathnameValue}</p>;
        }
        return (
            <div className="sourceSelector">
                <div className="textSearcher">
                    <Form>
                        <Form.Row>
                            <Col xs={8}>
                                {/* <Form.Group as={Col} md="12"> */}
                                <Form.Label>
                                    Search via folder path
                            </Form.Label>
                                <Form.Control
                                    // name="search"
                                    type="text"
                                    // ref={}
                                    onChange={this.onTextChange}
                                    value={pathnameValue}
                                />
                            </Col>
                            <Col className="searchButton">

                                {/* </Form.Group> */}
                                {/* <Form.Group as={Col} md="4"> */}
                                <Button type="submit" onClick={this.onSearchPath}>Search</Button>
                                {/* </Form.Group> */}
                            </Col>

                        </Form.Row>
                    </Form>
                </div>
                <p className="text-center">Click to select a data source</p>
                <div className="sourceList">
                    {isLoading ? <span style={{ textAlign: "center" }}>
                        {loader()}</span> : folderMap}
                </div>
            </div>
        )
    }

}

export default SourceSelector;


// WEBPACK FOOTER //
// ./src/components/sourcePicker/SourceSelector.js